import React from "react";
import { PlateTypeCaptureProfile } from "../../../Model/CaptureProfile";
import { LightPathCapability } from "../../../Model/ImagerCapabilities";
import DefaultImagingSettingBinning from "./DefaultImagingSettingBinning";
import DefaultImagingSettingSwitchButton from "./DefaultImagingSettingSwitchButton";

type Props = {
  style: React.CSSProperties;
  lightpathCapability: LightPathCapability;
  captureProfile: PlateTypeCaptureProfile;
  setCaptureProfile: (captureProfile: PlateTypeCaptureProfile) => void;
  onErrorOccur: (key: string) => void;
  onErrorCleared: (key: string) => void;
};

export default function FluorescenceOpticOptions({
  style,
  lightpathCapability,
  captureProfile,
  setCaptureProfile,
  onErrorOccur,
  onErrorCleared,
}: Props) {
  const binning = lightpathCapability.camera.binning;
  if (captureProfile.fluorescence == null) {
    throw new Error("Fluorescence capture profile is null");
  }

  if (captureProfile.fluorescence.binning == null) {
    throw new Error("Capture profile binning is null");
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        ...style,
      }}
    >
      <span
        style={{
          fontWeight: "bold",
          height: "57px",
          display: "flex",
          alignItems: "center",
          fontStyle: "normal",
          fontSize: 13,
          lineHeight: "15px"
        }}
      >
        Optic Options
      </span>
      <DefaultImagingSettingBinning
        binningDisplayValues={binning.binningDisplayValues}
        value={captureProfile.fluorescence.binning}
        style={{
          marginLeft: "17px",
        }}
        onChange={(name, value) =>
          setCaptureProfile({
            ...captureProfile,
            fluorescence: { ...captureProfile.fluorescence, binning: value },
          })
        }
        disabled={false}
        name="binning"
      />
    </div>
  );
}
